import { Navigate, useOutlet } from "react-router-dom";

export const AuthLayout = () => {
  const user = JSON.parse(localStorage.getItem("user-data"));
  const userPro = JSON.parse(localStorage.getItem("user-Pro"));
  console.log(userPro, "userProuserProuserPro");

  const outlet = useOutlet();

  if (user) {
    return <Navigate to="/dashboard" />;
  }

  return outlet;
};
